exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".handle{cursor:move!important;cursor:-webkit-grabbing!important}", "", {"version":3,"sources":["/var/www/mysmwebapp/src/components/Facconfig.vue"],"names":[],"mappings":"AACA,QACE,sBAAwB,AACxB,iCAAoC,CACrC","file":"Facconfig.vue","sourcesContent":["\n.handle {\n  cursor: move !important;\n  cursor: -webkit-grabbing !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7936054c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Facconfig.vue
// module id = 803
// module chunks = 36